import OldImages from 'components/forms/editQuality/oldImages';
import UploadImageDescription from './description';
import Images from './images';
import Uploader from './uploader';

type TUploadImageProps = {
  images: Array<IUploadImage>;
  oldImages?: Array<IImage>;
  mainImageGuid: string;
  removeImage: (item: string) => void;
  setImages: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
  setOldImages?: React.Dispatch<React.SetStateAction<IOldImage[]>>;
};

const UploadImageEdit = ({
  images,
  oldImages,
  mainImageGuid,
  setImages,
  setOldImages,
  removeImage,
}: TUploadImageProps) => {
  return (
    <>
      <div>
        <span className="font-extrabold text-gray-6"> عکس آگهی</span>
      </div>
      <div className="mt-1">
        <UploadImageDescription />
        <Uploader setFile={setImages} />
        <div className="flex justify-between mt-4">
          <span className="text-gray-6"> تصاویر بارگزاری شده</span>
          <small className="text-gray-6">تصویر اصلی آگهی</small>
        </div>
        {oldImages && oldImages.length > 0 && (
          <OldImages
            mainImageGuid={mainImageGuid}
            oldImages={oldImages}
            removeImage={removeImage}
          />
        )}
        {images && images.length > 0 && (
          <Images
            setOldImages={setOldImages}
            images={images}
            setFile={setImages}
          />
        )}
      </div>
    </>
  );
};

export default UploadImageEdit;
